var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser3Fill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_912_3693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 22.5H4V20.5C4 19.1739 4.52678 17.9021 5.46447 16.9645C6.40215 16.0268 7.67392 15.5 9 15.5H15C16.3261 15.5 17.5979 16.0268 18.5355 16.9645C19.4732 17.9021 20 19.1739 20 20.5V22.5ZM12 13.5C11.2121 13.5 10.4319 13.3448 9.7039 13.0433C8.97595 12.7417 8.31451 12.2998 7.75736 11.7426C7.20021 11.1855 6.75825 10.5241 6.45672 9.7961C6.15519 9.06815 6 8.28793 6 7.5C6 6.71207 6.15519 5.93185 6.45672 5.2039C6.75825 4.47595 7.20021 3.81451 7.75736 3.25736C8.31451 2.70021 8.97595 2.25825 9.7039 1.95672C10.4319 1.65519 11.2121 1.5 12 1.5C13.5913 1.5 15.1174 2.13214 16.2426 3.25736C17.3679 4.38258 18 5.9087 18 7.5C18 9.0913 17.3679 10.6174 16.2426 11.7426C15.1174 12.8679 13.5913 13.5 12 13.5Z",
    fill: "#24324F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_3693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3Fill);
export default __webpack_public_path__ + "static/media/user-3-fill.1847f5c5d7f6a01231e964e597ffae82.svg";
export { ForwardRef as ReactComponent };